export const UPDATE_LOAD_PAYMENT = 'UPDATE_LOAD_PAYMENT';
export const RESET_LOAD_PAYMENT = 'RESET_LOAD_PAYMENT';